/** In-memory mute flags from latest conversation list (for toast suppression). */
const mutedIds = new Set();

export function syncMutedFromConversations(conversations) {
  mutedIds.clear();
  for (const c of conversations || []) {
    if (c?.muted) mutedIds.add(Number(c.conversation_id));
  }
}

export function isConversationMuted(conversationId) {
  return mutedIds.has(Number(conversationId));
}

export function setConversationMutedLocal(conversationId, muted) {
  const id = Number(conversationId);
  if (muted) mutedIds.add(id);
  else mutedIds.delete(id);
}
